import $ from 'jquery';
import linkifyJq from 'linkify-jquery';
import IMask from 'imask';

linkifyJq($, document);

$(document).ready(function () {
  $(".linkify").linkify();

  $('.dropdown-submenu a.dropdown-submenu-target').on("click", function (e) {
    $(this).next('.dropdown-menu').toggle();
    e.stopPropagation();
    e.preventDefault();
  });
});
